const config = {
    apiUrl:process.env.REACT_APP_API_URL,
    whiteListApis:["/v1/authentication/login","/v1/authentication/signup"]
};

export default config;